/**
 * Helper: Query JSON
 * -----------------------------------------------------------------------------
 * Handle fetching JSON data from alternative Shopify page templates e.g.
 * `?view=json`
 *
 */
import JSON5 from 'json5'

/**
 *
 * @param {String} url - URL to request
 * @param {Object} options
 * @param {'JSON'|'JSON5'} options.format - format of the response, used for
 * parsing
 * @param {String} options.view - Template suffix for JSON view. Defaults to
 * 'resource'
 * @returns {Object}
 */
export async function queryJSONTemplate(
  url,
  {
    format = 'JSON5',
    view = 'resource',
  } = {},
) {
  const urlObject = new URL(url)

  urlObject.searchParams.set('view', view)

  const response = await fetch(urlObject.toString())
  const text = await response.text()
  const element = document.createElement('div')
  element.innerHTML = text

  const parser = format === 'JSON5' ? JSON5 : JSON
  const parsedJSON = parser.parse(element.innerHTML)

  element.remove()

  return parsedJSON
}
